import { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  CardContent,
  CircularProgress,
  DatePicker,
  FormControl,
  FullscreenDialog,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Tab,
  TabPanel,
  Tabs,
  TextareaAutosize,
  TextField,
  Tooltip,
  Typography,
} from "../../../components";
import { useImportContext } from "../../../contexts/import.context";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { AddLayout } from "../../../layouts";
import {
  AtivoServicoService,
  CondicoesPagamentoService,
  ConfiguracoesChecklistService,
  EmailPersonalizadoService,
  EnderecosEstoqueService,
  history,
  ImpressoraService,
  MeioPagamentoService,
  NotificacaoService,
  notification,
  OrcamentoServicosItensService,
  OrcamentoServicosService,
  OrcamentoServicosServicosService,
  PessoaService,
  ProdutosService,
  SessionService,
  StorageService,
  TabelaVendaService,
  UsuarioService,
} from "../../../services";
import {
  formatCelular,
  formatDate,
  montarFiltroPessoa,
  responseErros,
  userLogs,
} from "../../../utils";
import { isAtivoVeiculo } from "../../ordem-servicos/entities/campos-veiculo";
import AddPessoas from "../../pessoas/addPessoa/addPessoa.view";
import {
  AtivosOrcamentoServico,
  ChecklistOrcamentoServico,
  EnvioWhatsappDialog,
  HistoricoAtivosDialog,
  OrcamentoServicoListaPagamentos,
  OrcamentoServicoListaProdutos,
  OrcamentoServicoListaServicos,
  ResumoTotal,
} from "./components";
import HistorioClienteDialog from "./components/dialogComponents/historico-cliente-dialog.component";
import { OrcamentoServico, OrcamentoServicoPrintEntity } from "./entities";
import { orcamentoServicoValidator } from "./middlewares";

import shortid from "shortid";
import {
  calcularValorTotal,
  compararPagamentosTotalOrcamentoServico,
  possuiChecklistLancado,
} from "./add-orcamento-servico";

const orcamentoServicoService = new OrcamentoServicosService();
const pessoaService = new PessoaService();
const ativoServicoService = new AtivoServicoService();
const sessionService = new SessionService();
const produtosService = new ProdutosService();
const usuariosService = new UsuarioService();
const orcamentoServicosItensService = new OrcamentoServicosItensService();
const orcamentoServicosServicosService = new OrcamentoServicosServicosService();
const meioPagamentoService = new MeioPagamentoService();
const condicoesPagamentoService = new CondicoesPagamentoService();
const tabelaVendaService = new TabelaVendaService();
const impressoraService = new ImpressoraService();
const enderecosEstoqueService = new EnderecosEstoqueService();
const configuracoesChecklistService = new ConfiguracoesChecklistService();
const storageService = new StorageService();
const notificacaoService = new NotificacaoService();
const emailPersonalizadoService = new EmailPersonalizadoService();

let orcamentoServicoEntity = {
  status: "ABERTO",
};

let orcamentoServicoPrintEntity = {};

function tabProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function EndAdornmentCliente({ params, loading, clienteSelecionado }) {
  return (
    <Box
      sx={{
        position: "absolute",
        right: "1rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      {loading ? (
        <CircularProgress color="inherit" size={20} sx={{ ml: 1 }} />
      ) : null}

      <Box
        sx={{
          position: "relative",
          display: "flex",
          width: "4.5rem",
          height: "2rem",
        }}
      >
        {params.InputProps.endAdornment}
      </Box>

      {clienteSelecionado?.celular ? (
        <Tooltip
          arrow
          placement="bottom"
          title={
            <div className="modelo-div-title" style={{ fontSize: "12px" }}>
              {formatCelular(clienteSelecionado?.celular)}
            </div>
          }
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              ml: 1,
              cursor: "default",
              userSelect: "none",
            }}
            onMouseDown={(e) => e.preventDefault()}
            tabIndex={-1}
            aria-hidden={true}
          >
            <i
              className="ph-fill ph-phone"
              style={{
                fontSize: 20,
                position: "relative",
                top: "1px",
              }}
            ></i>
          </Box>
        </Tooltip>
      ) : null}
    </Box>
  );
}

const AddOrcamentoServico = ({ match }) => {
  const { id } = match.params;
  const [loading, setLoading] = useState(false);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [userLog, setUserLog] = useState({});
  const [orcamentoServico, setOrcamentoServico] = useState({
    ...orcamentoServicoEntity,
  });
  const [clienteList, setClienteList] = useState([]);
  const [isProdutoEdit, setIsProdutoEdit] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [servicoList, setServicoList] = useState([]);
  const [prestadoresList, setPrestadoresList] = useState([]);
  const [vendedoresList, setVendedoresList] = useState([]);
  const [usuariosList, setUsuariosList] = useState([]);
  const [produtoList, setProdutoList] = useState([]);
  const [listaOrcamentoServicoProdutos, setListaOrcamentoServicoProdutos] =
    useState([]);
  const [campoChave, setCampoChave] = useState(null);
  const [produto, setProduto] = useState(null);
  const [produtosSimilares, setProdutosSimilares] = useState([]);
  const [configuracoes, setConfiguracoes] = useState({});
  const [acrescimoPagamento, setAcrescimoPagamento] = useState(null);
  const [listaOrcamentoServicoPagamentos, setListaOrcamentoServicoPagamentos] =
    useState([]);
  const [listaOrcamentoServicoServicos, setListaOrcamentoServicoServicos] =
    useState([]);
  const [gerarPagamentos, setGerarPagamentos] = useState({});
  const [meioPagamentoSelecionado, setMeioPagamentoSelecionado] =
    useState(null);
  const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [meiosPagamentoCliente, setMeiosPagamentoCliente] = useState(null);
  const [condicaoPagParcelaList, setCondicaoPagParcelaList] = useState([]);
  const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  const [enderecosEstoqueList, setEnderecosEstoqueList] = useState([]);
  const [condicaoSelecionada, setCondicaoSelecionada] = useState(null);
  const [openHistoricoClienteDialog, setOpenHistoricoClienteDialog] =
    useState(false);
  const [openHistoricoAtivosDialog, setOpenHistoricoAtivosDialog] =
    useState(false);
  const [openDialogEnvioWhatsapp, setOpenDialogEnvioWhatsapp] = useState(false);

  const [idParaWhatsapp, setIdParaWhatsapp] = useState(id);

  const [checklistPreenchido, setChecklistPreenchido] = useState(false);
  const [avariaSelecionada, setAvariaSelecionada] = useState(0);
  const [acessoriosAtivo, setAcessoriosAtivo] = useState([]);
  const [locaisAvaria, setLocaisAvaria] = useState([]);
  const [tiposAvaria, setTiposAvaria] = useState([]);

  const [orcamentosServicos, setOrcamentosServicos] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [tabelas, setTabelas] = useState({
    cliente: null,
    grupoPessoa: null,
    todosProdutos: null,
  });
  const [isCadastroPessoaDialogOpen, setIsCadastroPessoaDialogOpen] =
    useState(false);
  const [abaValue, setAbaValue] = useState(0);
  const { initialCollapses } = useImportContext();

  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("orcamento-servicos-visualizar");
  const permissaoAlterarVendedor = permissoesHelper.temPermisao(
    "alterar-vendedor-por-item",
  );
  const permissaoAlterarValorProduto = permissoesHelper.temPermisao(
    "alterar-valor-produto-orcamento-servicos",
  );
  const permissaoAlterarValorServico = permissoesHelper.temPermisao(
    "alterar-valor-servico-orcamento-servicos",
  );
  const permissaoEditarChecklist = permissoesHelper.getPermisoesModulo(
    "orcamento-servicos-editar-checklist",
  );

  const checklistSomenteLeitura =
    !!id && checklistPreenchido && !permissaoEditarChecklist?.habilitado;

  const inputCliente = useRef();
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const dadosEmpresa = sessionService.getEmpresaAndUsuario();
  const dadosEmpresaRelatorio = sessionService.getEmpresaRelatorio();
  const tiposPessoa = [
    {
      tipoId: 1,
      setLista: (dados) => setClienteList(dados),
    },
  ];

  useEffect(() => {
    buscarDadosIniciais();
  }, [id]);

  const buscarDadosIniciais = async () => {
    await buscarMeiosPagamento();
    await buscarPrestadoresServico();
    if (!id) {
      orcamentoServicoEntity = new OrcamentoServico({
        dataAbertura: formatDate.toSend(new Date()),
        status: "ABERTO",
      });
      setOrcamentoServico({ ...orcamentoServicoEntity });
      buscarConfiguracaoChecklist();
      buscarAtivos();
    } else {
      await buscarOrcamentoServico();
    }
    await buscarUsuarios();
    buscarCondicoesPagamento();
    buscarConfiguracao();
    buscarVendedores();
    buscarEnderecosEstoque();
  };

  const buscarConfiguracao = () => {
    if (dadosEmpresa.empresa?.configuracoes) {
      const data = dadosEmpresa.empresa.configuracoes;
      orcamentoServicoEntity.setConfiguracoes(data);
      setOrcamentoServico({ ...orcamentoServicoEntity });
      setConfiguracoes(data);
    }
  };

  const atualizarEntidadePrint = () => {
    orcamentoServicoPrintEntity = new OrcamentoServicoPrintEntity(
      dadosEmpresaRelatorio,
      clienteSelecionado,
      orcamentoServicoEntity.itens || [],
      orcamentoServicoEntity.servicos || [],
      orcamentoServicoEntity.pagamentos || [],
      meioPagamentoList,
      prestadoresList,
      configuracoes?.modeloImpressaoPadraoOrcamentosServicos,
    );
  };

  const buscarOrcamentoServico = async () => {
    setLoading(true);
    const response = await orcamentoServicoService.getById(id);
    if (!response.isAxiosError) {
      const data = response.data;
      const ativosSalvos = data.ativos || [];
      orcamentoServicoEntity = new OrcamentoServico(data, id);
      orcamentoServicoEntity.initTotalPagamentos(data?.pagamentos || []);
      setOrcamentoServico({
        ...orcamentoServicoEntity,
        statusInicial: data.status,
      });
      setListaOrcamentoServicoPagamentos(data?.pagamentos || []);
      await buscarDadosClientes(data?.clienteId);
      await buscarAtivosParaEdicao(ativosSalvos);
      setChecklistPreenchido(possuiChecklistLancado(data));
      buscarConfiguracaoChecklist(data?.avarias || [], data?.acessorios || []);
      if (data?.itens?.length > 0) {
        await buscarProdutosAvancado(data?.itens || []);
      }
      if (data?.servicos?.length > 0) {
        const itens = data?.servicos.map((item) => ({
          ...item,
          totalItem: item.quantidade * item.valor - (item.desconto || 0),
        }));
        setListaOrcamentoServicoServicos(itens);
      }
    } else {
      responseErros(response);
    }
    setLoading(false);
  };

  const filtrarAtivoVeiculo = (lista) => {
    const veiculo = lista.find(isAtivoVeiculo);
    return veiculo ? [veiculo] : lista;
  };

  const buscarAtivos = async () => {
    const result = await ativoServicoService.getAll();
    if (!result.isAxiosError) {
      const listaDeAtivos = filtrarAtivoVeiculo(
        result.data.filter((ativo) => !!ativo?.ativado),
      );
      buscarCampoChave(listaDeAtivos);
      orcamentoServicoEntity.setAtivos(listaDeAtivos);
      setOrcamentoServico({ ...orcamentoServicoEntity });
    } else {
      responseErros(result);
    }
  };

  const buscarConfiguracaoChecklist = async (avarias = [], acessorios = []) => {
    setLoading(true);
    const response = await configuracoesChecklistService.getAll();
    if (!response.isAxiosError) {
      const configuracao = response.data || {};
      const mapaAvarias = new Map();
      avarias.forEach((item) => {
        if (item?.componenteId) {
          mapaAvarias.set(item.componenteId, item);
        }
      });

      const mapaAcessorios = new Map();
      acessorios.forEach((item) => {
        if (item?.acessorioId) {
          mapaAcessorios.set(item.acessorioId, item);
        }
      });

      setTiposAvaria(
        (configuracao.tipos || []).map((tipo) => ({
          ...tipo,
          nome: tipo.descricao,
        })),
      );

      setAcessoriosAtivo(
        (configuracao.acessorios || []).map((acessorio) => ({
          ...acessorio,
          contem: mapaAcessorios.has(acessorio.id)
            ? mapaAcessorios.get(acessorio.id).contem
            : false,
        })),
      );

      const locaisMapeados = (configuracao.locais || []).map((local) => ({
        ...local,
        componentes: (local.componentes || []).map((componente) => ({
          ...componente,
          tipoId: mapaAvarias.has(componente.id)
            ? mapaAvarias.get(componente.id).tipoId
            : null,
        })),
      }));

      setLocaisAvaria(locaisMapeados);
      setAvariaSelecionada(locaisMapeados.length ? 0 : null);
    } else {
      responseErros(response);
    }

    setLoading(false);
  };

  const buscarProdutosAvancado = async (itens) => {
    const produtosIds = itens.map(({ produtoId }) => produtoId);
    const filtro = {
      id: produtosIds,
      ativado: true,
      nonPaginated: true,
    };
    produtosService.getAllProdutosSimples(filtro).then((result) => {
      if (!result.isAxiosError) {
        setProdutoList(result.data);
        if (itens && itens?.length) {
          preencherItens(itens, result.data);
        }
      } else {
        responseErros(result);
      }
    });
  };

  const buscarEnderecosEstoque = () => {
    const filter = {
      nonPaginated: true,
    };
    enderecosEstoqueService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setEnderecosEstoqueList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const preencherItens = (itensBusca, produtos) => {
    const itens = itensBusca.map((item) => {
      const produtoBusca = produtos.find(
        (produto) => produto.id == item.produtoId,
      );
      return {
        ...item,
        descricao: produtoBusca?.descricao,
        totalItem: calcularValorTotal(item),
      };
    });
    orcamentoServicoEntity.setChangeItens(itens);
    setOrcamentoServico({
      ...orcamentoServicoEntity,
    });
    setListaOrcamentoServicoProdutos(itens);
  };

  const buscarCampoChave = (listaDeAtivos) => {
    for (const ativo of listaDeAtivos) {
      if (ativo?.camposPersonalizados?.length) {
        const chave = ativo.camposPersonalizados.find(
          (campo) => campo.campoChave,
        );
        setCampoChave(chave);
        break;
      }
    }
  };

  const buscarAtivosParaEdicao = async (ativosSalvos) => {
    const result = await ativoServicoService.getAll();
    if (!result.isAxiosError) {
      const listaDeAtivos = result.data.filter((ativo) => !!ativo?.ativado);
      orcamentoServicoEntity.setAtivosComValoresSalvos(
        listaDeAtivos,
        ativosSalvos,
      );
      setOrcamentoServico((prevState) => ({
        ...orcamentoServicoEntity,
        statusInicial: prevState.statusInicial,
      }));
    } else {
      responseErros(result);
    }
  };

  const buscarPrestadoresServico = async () => {
    const filtro = {
      nonPaginated: true,
      tiposPessoaId: 5,
      attributes: ["id", "nomeRazaoSocial"],
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setPrestadoresList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarVendedores = () => {
    const config = dadosEmpresa.empresa.configuracoes;
    if (id || config?.vendedorPorItemServico) {
      const filtro = {
        nonPaginated: true,
        tiposPessoaId: 4,
        vendedor: true,
        ativado: true,
        attributes: ["id", "nomeRazaoSocial"],
      };
      pessoaService.getAll(filtro).then((result) => {
        if (!result.isAxiosError) {
          setVendedoresList(result.data);
        } else {
          responseErros(result);
        }
      });
    } else {
      const usuario = {
        id: null,
        nomeRazaoSocial: dadosEmpresa.usuario.nome,
      };
      setVendedoresList([usuario]);
    }
  };

  const buscarUsuarios = async () => {
    const result = await usuariosService.getAllFiltroAvancado({
      nonPaginated: true,
    });
    if (!result.isAxiosError) {
      setUsuariosList(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const removerServicoCadastrado = async (idServico) => {
    setLoading(true);
    const res = await orcamentoServicosServicosService.deletarEmLote(idServico);
    if (!res.isAxiosError) {
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const removerProdutoCadastrado = async (idProduto) => {
    setLoading(true);
    const res = await orcamentoServicosItensService.deletarEmLote(idProduto);
    if (!res.isAxiosError) {
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const buscarMeiosPagamento = async (filtros) => {
    const filtro = {
      ...filtros,
      ativado: true,
      nonPaginated: true,
    };
    meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setMeioPagamentoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarCondicoesPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    condicoesPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setCondicaoPagamentoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDocumentosCliente = async (clienteId) => {
    setLoadingHistorico(true);
    orcamentoServicoService
      .getAll({ clienteId })
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data.rows?.length) {
            setOrcamentosServicos(result.data.rows);
            setTotalItems(result.data.count);
          } else {
            setOrcamentosServicos([]);
            setTotalItems(0);
          }
        } else {
          responseErros(result);
        }
      })
      .finally(() => setLoadingHistorico(false));
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(orcamentoServicoEntity);
    setUserLog(logs);
  }

  const handleDateChange = (fieldName, date) => {
    const isValidDate = (d) => d instanceof Date && !isNaN(d);
    if (!date || !isValidDate(date) || date.getFullYear() < 2000) {
      date = "Invalid Date";
    }
    orcamentoServicoEntity.setHandleChangeDate(fieldName, date);
    setOrcamentoServico(() => ({
      ...orcamentoServicoEntity,
    }));
  };

  async function validarOrcamentoServico(indiceSelecionado) {
    const pagamentosTotalOrcamentoServico =
      compararPagamentosTotalOrcamentoServico(orcamentoServicoEntity);
    if (pagamentosTotalOrcamentoServico) {
      setLoading(false);
      navegarAtePagamentos();
      return notification.alertaGenericos(
        "É necessário atualizar valor da(s) parcela(s)",
      );
    }
    await handleSubmit(indiceSelecionado);
  }

  async function filtrarImagensChecklist() {
    const nomeArquivos = [];
    const imagensUpload = [];

    for (const image of orcamentoServicoEntity.imagens || []) {
      if (image && typeof image === "string" && image.startsWith("data:")) {
        imagensUpload.push(image);
      } else if (image && typeof image === "string") {
        nomeArquivos.push(image.substring(image.lastIndexOf("/") + 1));
      }
    }

    if (imagensUpload.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < imagensUpload.length; i++) {
        const dataUrl = imagensUpload[i];
        const blob = await (await fetch(dataUrl)).blob();
        formData.append(
          "image",
          blob,
          `imagem-${i}-${shortid.generate()}.foto-orcamento-servico`,
        );
      }

      const resStorage = await storageService.addImages(formData);
      if (resStorage.isAxiosError) {
        throw resStorage;
      }

      if (Array.isArray(resStorage.data)) {
        const nomesUpload = resStorage.data.map((item) => item.fileName);
        nomeArquivos.push(...nomesUpload);
      }
    }

    return nomeArquivos;
  }

  async function montarBodyComImagens() {
    const body = { ...orcamentoServicoEntity };
    const nomesArquivos = await filtrarImagensChecklist();
    body.imagens = nomesArquivos.map((fileName, index) => ({
      nomeArquivo: fileName,
      ordem: index,
    }));
    return body;
  }

  const handleSubmit = async (indiceSelecionado) => {
    setLoading(true);
    orcamentoServicoValidator
      .validate(orcamentoServicoEntity, {
        abortEarly: false,
        context: { locaisAvaria, checklistSomenteLeitura },
      })
      .then(async () => {
        if (id) {
          const body = await montarBodyComImagens();
          const response = await orcamentoServicoService.atualizar(id, body);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            initialCollapses();
            handleCancelar();
            history.push("/faturamento/orcamento-servicos");
          } else {
            buscarOrcamentoServico();
            responseErros(response);
          }
        } else {
          const body = await montarBodyComImagens();
          const response = await orcamentoServicoService.cadastrar(body);
          setLoading(false);
          if (!response.isAxiosError) {
            setOrcamentoServico({ ...orcamentoServico, ...response.data });
            notification.cadastroSucesso();
            if (indiceSelecionado === 0) {
              const permissaoDeny = permissoesHelper.temPermisao(
                "orcamentos-enviar-documento-apos-criacao",
              );
              const props = {
                title: "Documento cadastrado com sucesso",
                text: `#${response.data.numeroDocumento}`,
                icon: "success",
                confirmButtonText: "IMPRIMIR",
                cancelButtonText: permissaoDeny ? "EMAIL" : "FECHAR",
                showCancelButton: true,
                showCloseButton: permissaoDeny,
                closeButtonHtml:
                  "<i class='ph-bold ph-x' style='font-size: 21px' aria-hidden='true'></i>",
                dangerMode: true,
              };
              if (permissaoDeny && dadosEmpresa.empresa?.whatsappSimples) {
                props.width = "min(38rem, calc(100vw - 2rem))";
                props.denyButtonText = "WHATSAPP";
                props.showDenyButton = true;
              }
              const confirmacaoAlerta = await notification.confirmacaoGenericos(
                props,
              );
              if (confirmacaoAlerta.isConfirmed) {
                await buscarOS(response.data.id);
                initialCollapses();
                handleCancelar();
                history.push("/faturamento/orcamento-servicos");
              } else if (confirmacaoAlerta?.isDenied) {
                atualizarEntidadePrint();
                setIdParaWhatsapp(response.data.id);
                setOpenDialogEnvioWhatsapp(true);
              } else {
                if (confirmacaoAlerta?.dismiss === "cancel" && permissaoDeny) {
                  await enviarEmail(
                    response.data.id,
                    response.data.numeroDocumento,
                  );
                }
                initialCollapses();
                handleCancelar();
                history.push("/faturamento/orcamento-servicos");
              }
            } else {
              handleCancelar();
            }
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err?.message?.includes("pagamento")) {
          navegarAtePagamentos();
        }
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    orcamentoServicoEntity = new OrcamentoServico({
      dataAbertura: formatDate.toSend(new Date()),
    });
    setOrcamentoServico({ ...orcamentoServicoEntity });
  };

  const onSearchChangePessoas = (event, inputRef, tiposPessoaId) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const filtros = montarFiltroPessoa(event.target?.value, tiposPessoaId);
      setLoadingAutoComplete(true);
      buscarPessoasPorTipo(filtros, tiposPessoaId);
    }
  };

  const buscarPessoasPorTipo = async (filtros, tiposPessoaId) => {
    const filtro = {
      ...filtros,
      tiposPessoaId,
      nonPaginated: true,
      ativado: true,
    };
    const tipoPessoaTemp = tiposPessoa.find(
      ({ tipoId }) => tipoId === tiposPessoaId,
    );
    const pessoas = await buscarPessoas(filtro);
    setLoadingAutoComplete(false);
    if (pessoas?.length) {
      tipoPessoaTemp?.setLista(pessoas);
    }
  };

  async function buscarPessoas(filtros) {
    const res = await pessoaService.getAll({
      ...filtros,
      attributes: [
        "id",
        "codigo",
        "nomeRazaoSocial",
        "apelidoFantasia",
        "cnpjCpf",
        "celular",
      ],
    });
    if (!res.isAxiosError) {
      return res.data;
    } else {
      responseErros(res);
    }
    return [];
  }

  const buscarProdutosSimilares = async (produtoId) => {
    if (produtoId) {
      produtosService.getById(produtoId).then((result) => {
        if (!result.isAxiosError) {
          setProdutosSimilares(result.data.similares);
        } else {
          responseErros(result);
        }
      });
    }
  };

  const buscarTodasTabelasVenda = async (pessoaId, intGrupoPessoaId) => {
    setLoading(true);
    try {
      const filtros = {
        ativado: true,
        nonPaginated: true,
        restritiva: true,
        tabelaRegente: true,
      };
      const response = await tabelaVendaService.getAll(filtros);
      if (response.isAxiosError) {
        responseErros(response);
        return;
      }
      const tabelasProcessadas = response.data.reduce(
        (acc, tabela) => {
          const pessoa = tabela?.pessoaIds.find(
            (tabelaPessoa) => tabelaPessoa.intPessoaId == pessoaId,
          );
          if (pessoa) {
            acc.cliente = tabela;
          } else if (tabela.intGrupoPessoaId === intGrupoPessoaId) {
            acc.grupoPessoa = tabela;
          } else {
            acc.todosProdutos = tabela;
          }
          return acc;
        },
        { cliente: null, grupoPessoa: null, todosProdutos: null },
      );
      setTabelas(tabelasProcessadas);
    } catch (error) {
      console.error("Erro ao buscar tabelas:", error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeAutocompleteCliente = async (newValue) => {
    if (!newValue || (newValue && newValue.id !== clienteSelecionado?.id)) {
      setListaOrcamentoServicoPagamentos([]);
      orcamentoServicoEntity.setChangePagamentos([]);
      setGerarPagamentos((prevState) => ({
        ...prevState,
        valorTitulo: orcamentoServicoEntity?.totalOrcamentoServico,
      }));
    }
    orcamentoServicoEntity.setHandleChangeAutoComplete("clienteId", newValue);
    setOrcamentoServico(() => ({
      ...orcamentoServicoEntity,
    }));
    setClienteSelecionado(newValue);
    await buscarDadosClientes(newValue?.id);
    if (newValue?.clientes?.length) {
      buscarTodasTabelasVenda(
        newValue?.id,
        newValue?.clientes?.[0]?.grupoPessoaId,
      );
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  const handleChangeInput = (event) => {
    orcamentoServicoEntity.setHandleChangeInput(
      event.target.name,
      event.target.value,
    );
    setOrcamentoServico(() => ({
      ...orcamentoServicoEntity,
    }));
  };

  const handleCloseCadastroCliente = () => {
    buscarPessoasPorTipo();
    setOrcamentoServico(() => ({
      ...orcamentoServicoEntity,
    }));
    setIsCadastroPessoaDialogOpen(false);
  };

  const buscarDadosClientes = async (clienteId) => {
    if (!clienteId) return;
    pessoaService.getById(clienteId).then((result) => {
      if (!result.isAxiosError) {
        setClienteSelecionado(result.data);
        buscarDocumentosCliente(clienteId);
        filterMeiosPagamentoCliente(result.data.clientes[0]);
      } else {
        responseErros(result);
      }
    });
  };

  const filterMeiosPagamentoCliente = (cliente) => {
    const list = meioPagamentoList?.length ? meioPagamentoList : [];
    if (cliente?.meiosPagamento?.length) {
      const meioPagamentoIds = cliente.meiosPagamento.map(
        ({ meioPagamentoId }) => meioPagamentoId,
      );
      const filterMeioPagamento = list?.filter((item) =>
        meioPagamentoIds.includes(item.id),
      );
      setMeiosPagamentoCliente(filterMeioPagamento);
      const meioPagamentoValido = meioPagamentoIds.find(
        (id) => id === gerarPagamentos?.meioPagamentoId,
      );
      if (gerarPagamentos?.meioPagamentoId && !meioPagamentoValido) {
        setGerarPagamentos((prevState) => ({
          ...prevState,
          meioPagamentoId: null,
          condicaoPagamentoId: null,
        }));
        setCondicaoPagParcelaList([]);
      }
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  async function buscarOS(idParam) {
    setLoading(true);
    const idDoc = idParam || id;
    if (!idDoc) {
      setLoading(false);
      return notification.alertaGenericos(
        "Orçamento de serviço não cadastrado",
      );
    }
    atualizarEntidadePrint();
    const result = await orcamentoServicoService.getOS(
      idDoc,
      orcamentoServicoPrintEntity,
    );
    setLoading(false);
    if (!result.isAxiosError) {
      if (configuracoes?.impressaoDiretaOrcamentosServicos) {
        await print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function openAbaDanfeBase64(base64Pdf) {
    try {
      const response = await fetch(`data:application/pdf;base64,${base64Pdf}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  async function print(base64Pdf) {
    setLoading(true);
    try {
      if (!base64Pdf) {
        notification.erroGenericos("Erro ao gerar imagem para impressão.");
        return;
      }
      const body = {
        base64Pdf,
        printerName: configuracoes?.impressoraTermica || null,
      };
      const resultImpressao = await impressoraService.imprimirTermicaPdf(body);
      if (!resultImpressao.isAxiosError) {
        notification.sucessoGenericos("Impressão realizada com sucesso!");
      } else {
        responseErros(resultImpressao);
      }
    } catch (error) {
      console.error("Erro na impressão:", error);
      notification.erroGenericos("Erro ao realizar a impressão.");
    } finally {
      setLoading(false);
    }
  }

  const enviarEmail = async (id, numeroDocumento) => {
    if (clienteSelecionado?.email) {
      setLoading(true);
      try {
        const getPrimeiroNome = (nomeCompleto) => {
          return nomeCompleto?.split(" ")[0] || "";
        };
        const nomeCliente = clienteSelecionado?.nomeRazaoSocial;
        const resultEmail = await emailPersonalizadoService.getInformacoesEmail(
          {
            contexto: "orcamento-servico",
            apelidoFantasia: dadosEmpresa?.empresa?.fantasia,
            numeroDocumento,
            dataVencimento: orcamentoServico?.dataVencimento,
            nomeCompletoCliente: nomeCliente,
            primeiroNomeCliente: getPrimeiroNome(nomeCliente),
            nomeUsuario: dadosEmpresa.usuario?.nome,
          },
        );
        if (resultEmail.isAxiosError) {
          const message = resultEmail?.response?.data?.message;
          throw new Error(message ?? "Erro interno de servidor");
        }

        const {
          subject = "Documento referente a Orçamento de Serviço",
          text = "Segue orçamento de serviço solicitada em anexo",
        } = resultEmail.data ?? {};

        const dadosEmpresaRelatorio = sessionService.getEmpresaRelatorio();
        const dto = new OrcamentoServicoPrintEntity(
          dadosEmpresaRelatorio,
          clienteSelecionado,
          orcamentoServicoEntity.itens || [],
          orcamentoServicoEntity.servicos || [],
          orcamentoServicoEntity.pagamentos || [],
          meioPagamentoList,
          prestadoresList,
          configuracoes?.modeloImpressaoPadraoOrcamentosServicos,
        );
        const result = await orcamentoServicoService.getOS(id, dto);
        if (result.isAxiosError) {
          const message = resultEmail?.response?.data?.message;
          throw new Error(message ?? "Erro interno de servidor");
        }

        const anexo = {
          filename: `Orcamento-Servico_Nº${numeroDocumento}`,
          type: "application/pdf",
          content: result.data,
        };
        const resultEnvio = await notificacaoService.enviarEmail({
          to: clienteSelecionado.email,
          subject,
          text,
          attachments: [anexo],
        });
        if (!resultEnvio.isAxiosError) {
          notification.sucessoGenericos("Documento enviado com sucesso");
        } else {
          throw new Error("Erro ao enviar documento via email");
        }
      } catch (error) {
        console.error(error);
        notification.alertaGenericos(error.message);
      } finally {
        setLoading(false);
      }
    } else {
      notification.alertaGenericos("Este cliente não possui e-mail cadastrado");
    }
  };

  const navegarAtePagamentos = () => {
    setAbaValue(2);
    setTimeout(() => {
      const ref = document?.getElementById("pagamentos-os");
      ref?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const cancelarOrcamentoServico = async () => {
    const retornoAlerta = await notification.confirmacao(
      "Cancelar!",
      "Tem certeza que deseja cancelar esse orçamento de serviço?",
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await orcamentoServicoService.cancelar(id);
      if (!result.isAxiosError) {
        notification.alteracaoSucesso();
        buscarDadosIniciais();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const verificarStatus = (status) => {
    switch (status) {
      case "ABERTO":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#4FBB53" }}></i>
        );
      case "IMPORTADO":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#004780" }}></i>
        );
      case "CANCELADO":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#DC3545" }}></i>
        );
    }
  };

  const isImportado =
    id &&
    (orcamentoServico?.statusInicial === "IMPORTADO" ||
      orcamentoServico?.status === "IMPORTADO");
  const isCancelado =
    id &&
    (orcamentoServico?.statusInicial === "CANCELADO" ||
      orcamentoServico?.status === "CANCELADO");

  return (
    <AddLayout
      id={id}
      title={
        id ? "Editar Orçamento de Serviço" : "Cadastrar Orçamento de Serviço"
      }
      showUpdate={
        permissoesHelper.temPermisao("orcamento-servicos-editar") &&
        !isImportado &&
        !isCancelado
      }
      onClickSalvar={validarOrcamentoServico}
      loading={loading}
      codigo={id ? `Nº Documento ${orcamentoServico?.numeroDocumento}` : null}
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      actions={
        id ? (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {permissoesHelper.temPermisao("orcamento-servicos-cancelar") &&
              !isCancelado && (
                <Button
                  variant="outlined"
                  className="mb-1"
                  size="small"
                  color="primary"
                  onClick={cancelarOrcamentoServico}
                  disabled={orcamentoServico?.status !== "ABERTO"}
                >
                  Cancelar Orçamento
                </Button>
              )}
            <Tooltip title="Imprimir OS" arrow placement="left">
              <IconButton onClick={async () => await buscarOS()}>
                <i className="ph-fill ph-printer" style={{ fontSize: 18 }}></i>
              </IconButton>
            </Tooltip>
            <Tooltip title="Enviar por Email" arrow placement="bottom">
              <IconButton
                onClick={() =>
                  enviarEmail(id, orcamentoServico.numeroDocumento)
                }
              >
                <i className="ph-fill ph-envelope" style={{ fontSize: 18 }}></i>
              </IconButton>
            </Tooltip>
            {dadosEmpresa.empresa.whatsappSimples && (
              <Tooltip title="Enviar por WhatsApp" arrow placement="bottom">
                <IconButton
                  onClick={() => {
                    atualizarEntidadePrint();
                    setIdParaWhatsapp(id);
                    setOpenDialogEnvioWhatsapp(true);
                  }}
                >
                  <i
                    className="ph-fill ph-whatsapp-logo"
                    style={{ fontSize: 18, color: "#48A34C" }}
                  ></i>
                </IconButton>
              </Tooltip>
            )}
          </div>
        ) : (
          <></>
        )
      }
      actionsTotalizadores={
        <ResumoTotal
          orcamentoServico={orcamentoServico}
          setOrcamentoServico={setOrcamentoServico}
          orcamentoServicoEntity={orcamentoServicoEntity}
          abaValue={abaValue}
          listaServicos={listaOrcamentoServicoServicos}
          setListaServicos={setListaOrcamentoServicoServicos}
          listaProdutos={listaOrcamentoServicoProdutos}
          setListaProdutos={setListaOrcamentoServicoProdutos}
        />
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <TextField
            id="numeroDocumento"
            name="numeroDocumento"
            type="number"
            label="Nº Documento"
            variant="outlined"
            margin="normal"
            disabled
            value={orcamentoServico?.numeroDocumento ?? ""}
            InputProps={{ inputProps: { min: 0 } }}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <FormControl
            variant="outlined"
            margin="normal"
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <Autocomplete
              id="clienteId"
              name="clienteId"
              options={clienteList}
              autoHighlight
              getOptionLabel={(option) => {
                let codigoPessoa = option?.codigo ? `${option.codigo} - ` : "";
                let descricaoPessoa =
                  codigoPessoa + `${option.nomeRazaoSocial}`;
                return option ? descricaoPessoa : "";
              }}
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText={
                document.getElementById("clienteId")?.value?.length ? (
                  <Grid container spacing={1}>
                    <Grid item xs={12} fullWidth>
                      Nenhum cliente encontrado
                    </Grid>
                  </Grid>
                ) : (
                  "Digite e pressione Enter"
                )
              }
              disabled={isImportado || isCancelado}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Cliente"}
                  error={inputErros.get("clienteId")}
                  required
                  disabled={isImportado || isCancelado}
                  variant={"outlined"}
                  onKeyDown={(e) => onSearchChangePessoas(e, inputCliente, 1)}
                  inputRef={inputCliente}
                  inputProps={{ ...params.inputProps, enterKeyHint: "search" }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <EndAdornmentCliente
                        params={params}
                        loading={loadingAutoComplete}
                        clienteSelecionado={clienteSelecionado}
                      />
                    ),
                  }}
                />
              )}
              onChange={(_, newValue) => onChangeAutocompleteCliente(newValue)}
              value={clienteSelecionado}
            />
            <Tooltip title="Cadastrar Cliente" arrow placement="bottom">
              <Button
                id="buttonAdicionarCliente"
                variant="contained"
                disabled={isImportado || isCancelado}
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => setIsCadastroPessoaDialogOpen(true)}
              >
                <i
                  className="ph-bold ph-plus"
                  style={{ color: "#fff", fontSize: 15 }}
                />
              </Button>
            </Tooltip>
            {!id &&
            orcamentoServico?.clienteId &&
            orcamentosServicos?.length ? (
              <>
                {loadingHistorico ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <>
                    <Tooltip
                      title="Visualizar Histórico Cliente"
                      arrow
                      placement="bottom"
                    >
                      <Button
                        id="buttonHistoricoCliente"
                        variant="contained"
                        disabled={!orcamentoServico?.clienteId}
                        size="small"
                        sx={{
                          height: "35px",
                          borderRadius: "20%",
                          minWidth: "15px",
                          boxShadow: "none",
                        }}
                        onClick={() => {
                          setOpenHistoricoClienteDialog(true);
                        }}
                      >
                        <i
                          className="ph-fill ph-shopping-cart"
                          style={{ fontSize: 15, color: "white" }}
                        ></i>
                      </Button>
                    </Tooltip>
                    <Tooltip
                      title="Visualizar Histórico de Ativos"
                      arrow
                      placement="bottom"
                    >
                      <Button
                        id="buttonHistoricoAtivos"
                        variant="contained"
                        disabled={!orcamentoServico?.clienteId}
                        size="small"
                        sx={{
                          height: "35px",
                          borderRadius: "20%",
                          minWidth: "15px",
                          boxShadow: "none",
                        }}
                        onClick={() => setOpenHistoricoAtivosDialog(true)}
                      >
                        <i
                          className="ph-fill ph-toolbox"
                          style={{ fontSize: 15, color: "white" }}
                        ></i>
                      </Button>
                    </Tooltip>
                  </>
                )}
              </>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Tooltip
            title="Data de vencimento sugerida de acordo com parâmetro presente em configurações."
            placement="top"
          >
            <DatePicker
              id="dataVencimento"
              name="dataVencimento"
              label="Data de Vencimento"
              format="dd/MM/yyyy"
              disabled
              margin
              variant="filled"
              value={
                orcamentoServico?.dataVencimento
                  ? orcamentoServico.dataVencimento
                  : null
              }
              onChange={(date) => {
                setInputErro([]);
                handleDateChange("dataVencimento", date);
              }}
              error={inputErros.get("dataVencimento")}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="status"
            name="status"
            label="Status"
            variant="outlined"
            disabled
            margin="normal"
            value={orcamentoServico?.status ?? ""}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {verificarStatus(orcamentoServico?.status)}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AtivosOrcamentoServico
            setOrcamentoServico={setOrcamentoServico}
            orcamentoServicoEntity={orcamentoServicoEntity}
            orcamentosServicos={orcamentosServicos}
            isFechado={isImportado || isCancelado}
            somenteLeitura={!!id}
          />
        </Grid>

        <Grid item xs={12}>
          <ChecklistOrcamentoServico
            orcamentoServicoEntity={orcamentoServicoEntity}
            orcamentoServico={orcamentoServico}
            setOrcamentoServico={setOrcamentoServico}
            acessoriosAtivo={acessoriosAtivo}
            setAcessoriosAtivo={setAcessoriosAtivo}
            locaisAvaria={locaisAvaria}
            setLocaisAvaria={setLocaisAvaria}
            tiposAvaria={tiposAvaria}
            avariaSelecionada={avariaSelecionada}
            setAvariaSelecionada={setAvariaSelecionada}
            isFechado={isImportado || isCancelado}
            somenteLeitura={checklistSomenteLeitura}
            loading={loading}
            handleChangeInput={handleChangeInput}
          />
        </Grid>

        {configuracoes?.exibirDescricaoServico && (
          <Grid item xs={12}>
            <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
              Descrição do Serviço
            </Typography>
            <TextareaAutosize
              id="observacoes"
              name="observacoes"
              className="textRolagem bg-transparent"
              label="Observacao"
              maxLength={550}
              disabled={isImportado || isCancelado}
              value={orcamentoServico?.observacoes}
              onChange={handleChangeInput}
            />
          </Grid>
        )}
      </Grid>

      <hr className="mt-4 mb-2" />

      <Grid item xs={12}>
        <Paper>
          <Tabs
            value={abaValue}
            onChange={(e, newValue) => setAbaValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="SERVIÇOS" {...tabProps(0)} />
            <Tab label="PRODUTOS" {...tabProps(1)} />
            <Tab label="PAGAMENTOS" {...tabProps(2)} disabled={isCancelado} />
          </Tabs>
        </Paper>

        <CardContent>
          <TabPanel value={abaValue} index={0}>
            <OrcamentoServicoListaServicos
              id={id}
              isFechado={isImportado || isCancelado}
              orcamentoServico={orcamentoServico}
              setOrcamentoServico={setOrcamentoServico}
              orcamentoServicoEntity={orcamentoServicoEntity}
              servicoList={servicoList}
              setServicoList={setServicoList}
              prestadoresList={prestadoresList}
              removerServicoCadastrado={removerServicoCadastrado}
              listaOrcamentoServicoPagamentos={listaOrcamentoServicoPagamentos}
              setListaOrcamentoServicoPagamentos={
                setListaOrcamentoServicoPagamentos
              }
              listaOrcamentoServicoServicos={listaOrcamentoServicoServicos}
              setListaOrcamentoServicoServicos={
                setListaOrcamentoServicoServicos
              }
              permissaoAlterarValorServico={permissaoAlterarValorServico}
            />
          </TabPanel>

          <TabPanel value={abaValue} index={1}>
            <OrcamentoServicoListaProdutos
              id={id}
              isFechado={isImportado || isCancelado}
              setOrcamentoServico={setOrcamentoServico}
              produtoList={produtoList}
              setProdutoList={setProdutoList}
              listaOrcamentoServicoProdutos={listaOrcamentoServicoProdutos}
              setListaOrcamentoServicoProdutos={
                setListaOrcamentoServicoProdutos
              }
              removerProdutoCadastrado={removerProdutoCadastrado}
              setLoading={setLoading}
              orcamentoServico={orcamentoServico}
              orcamentoServicoEntity={orcamentoServicoEntity}
              buscarProdutosSimilares={buscarProdutosSimilares}
              produtosSimilares={produtosSimilares}
              setProdutosSimilares={setProdutosSimilares}
              produto={produto}
              setProduto={setProduto}
              meioPagamentoSelecionado={meioPagamentoSelecionado}
              acrescimoPagamento={acrescimoPagamento}
              tabelas={tabelas}
              listaOrcamentoServicoPagamentos={listaOrcamentoServicoPagamentos}
              setListaOrcamentoServicoPagamentos={
                setListaOrcamentoServicoPagamentos
              }
              vendedoresList={vendedoresList}
              setVendedoresList={setVendedoresList}
              usuariosList={usuariosList}
              configuracoes={configuracoes}
              permissaoAlterarVendedor={permissaoAlterarVendedor}
              permissaoAlterarValorProduto={permissaoAlterarValorProduto}
              isProdutoEdit={isProdutoEdit}
              setIsProdutoEdit={setIsProdutoEdit}
              enderecosEstoqueList={enderecosEstoqueList}
            />
          </TabPanel>

          <TabPanel value={abaValue} index={2}>
            <div id="pagamentos-os">
              <OrcamentoServicoListaPagamentos
                id={id}
                orcamentoServico={orcamentoServico}
                setOrcamentoServico={setOrcamentoServico}
                listaOrcamentoServicoPagamentos={
                  listaOrcamentoServicoPagamentos
                }
                setListaOrcamentoServicoPagamentos={
                  setListaOrcamentoServicoPagamentos
                }
                condicaoPagamentoList={condicaoPagamentoList}
                gerarPagamentos={gerarPagamentos}
                setGerarPagamentos={setGerarPagamentos}
                condicaoSelecionada={condicaoSelecionada}
                setCondicaoSelecionada={setCondicaoSelecionada}
                condicaoPagParcelaList={condicaoPagParcelaList}
                setCondicaoPagParcelaList={setCondicaoPagParcelaList}
                meioPagamentoList={meioPagamentoList}
                meiosPagamentoCliente={meiosPagamentoCliente}
                orcamentoServicoEntity={orcamentoServicoEntity}
                meioPagamentoSelecionado={meioPagamentoSelecionado}
                setMeioPagamentoSelecionado={setMeioPagamentoSelecionado}
                listaOrcamentoServicoProdutos={listaOrcamentoServicoProdutos}
                setListaOrcamentoServicoProdutos={
                  setListaOrcamentoServicoProdutos
                }
                setAcrescimoPagamento={setAcrescimoPagamento}
                produto={produto}
                setProduto={setProduto}
                isFechado={isImportado || isCancelado}
              />
            </div>
          </TabPanel>
        </CardContent>
      </Grid>
      <HistorioClienteDialog
        open={openHistoricoClienteDialog}
        setOpen={setOpenHistoricoClienteDialog}
        clienteId={orcamentoServico?.clienteId}
        orcamentosServicos={orcamentosServicos}
        setOrcamentosServicos={setOrcamentosServicos}
        totalItems={totalItems}
        setTotalItems={setTotalItems}
        prestadoresList={prestadoresList}
        orcamentoServicoEntity={orcamentoServicoEntity}
        setOrcamentoServico={setOrcamentoServico}
        campoChave={campoChave}
        setListaOrcamentoServicoProdutos={setListaOrcamentoServicoProdutos}
        setListaOrcamentoServicoServicos={setListaOrcamentoServicoServicos}
      />
      <HistoricoAtivosDialog
        open={openHistoricoAtivosDialog}
        setOpen={setOpenHistoricoAtivosDialog}
        cliente={clienteSelecionado}
        orcamentosServicos={orcamentosServicos}
        orcamentoServicoEntity={orcamentoServicoEntity}
        setOrcamentoServico={setOrcamentoServico}
      />
      <FullscreenDialog
        open={isCadastroPessoaDialogOpen}
        handleClose={handleCloseCadastroCliente}
        content={
          <AddPessoas
            match={{ params: { id: null } }}
            isFullscreenDialog
            onChangeCliente={onChangeAutocompleteCliente}
            handleCloseFullscreenDialog={handleCloseCadastroCliente}
          />
        }
      />
      <EnvioWhatsappDialog
        open={openDialogEnvioWhatsapp}
        setOpen={setOpenDialogEnvioWhatsapp}
        data={{
          ...orcamentoServico,
          id: idParaWhatsapp,
          cliente: clienteSelecionado,
          empresa: dadosEmpresa?.empresa,
          imagemLogo: dadosEmpresa?.empresa?.imagemLogo,
          dataVencimentoFormat: orcamentoServico?.dataVencimento,
          dto: orcamentoServicoPrintEntity,
        }}
        initialCollapses={initialCollapses}
      />
    </AddLayout>
  );
};

export default AddOrcamentoServico;
